module.exports = __webpack_public_path__ + "img/charm_3.5b931708.svg";